import { PromptTemplateCategory } from '../types';

export const dialogue: PromptTemplateCategory = {
  title: "Diálogo",
  icon: "💬",
  templates: [
    {
      title: "Plantilla de Entrevista de Podcast",
      content: `Escribe una entrevista estilo podcast entre dos hablantes.
- El hablante 1 es el presentador: [un periodista tecnológico curioso y entusiasta].
- El hablante 2 es el invitado: [un reconocido investigador de IA que acaba de publicar un artículo revolucionario].
- El tema de discusión es [el futuro de la colaboración entre humanos e IA en campos creativos].
- El tono debe ser [conversacional, perspicaz y ocasionalmente humorístico].
- Incluye un intercambio natural con preguntas de seguimiento y anécdotas.

Formatea cada línea como "Speaker 1:" o "Speaker 2:" seguido de su diálogo.`,
      mode: 'multi'
    },
    {
      title: "Plantilla de Debate",
      content: `Escribe un debate estructurado entre dos hablantes con puntos de vista opuestos.
- El hablante 1 argumenta [a favor de que el trabajo remoto se convierta en el estándar permanente].
- El hablante 2 argumenta [que la colaboración en oficina es esencial para la innovación].
- Ambos hablantes deben presentar [argumentos bien razonados con ejemplos del mundo real].
- El tono debe ser [respetuoso pero apasionado].
- Cada hablante debe responder directamente a los puntos del otro.

Formatea cada línea como "Speaker 1:" o "Speaker 2:" seguido de su diálogo.`,
      mode: 'multi'
    },
    {
      title: "Plantilla de Diálogo para Aprendizaje de Idiomas",
      content: `Escribe un diálogo conversacional entre dos hablantes para estudiantes de idiomas.
- El escenario es [pedir comida en un mercado callejero concurrido].
- El hablante 1 es [un vendedor local amigable que recomienda sus mejores platos].
- El hablante 2 es [un viajero que prueba la cocina local por primera vez].
- Incluye [vacilaciones naturales, frases corteses y contexto cultural].
- El diálogo debe sentirse auténtico y ayudar a los estudiantes con [frases conversacionales cotidianas].

Formatea cada línea como "Speaker 1:" o "Speaker 2:" seguido de su diálogo.`,
      mode: 'multi'
    }
  ]
};
